import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';

export interface SelectComponentProps {
  value: string;
  options: { name: string; value: string; }[];
  addEmptyOption: boolean;
  handleChange: (value: string) => void;
  required: boolean;
  placeholder: string;
  label: string;
  className?: string;
  width?: string;
}

const SelectComponent = (props: SelectComponentProps) => {
  if (props.options === null) {
    return <LoadingContainer/>;
  }

  const selectOptions = props.options.map((option, index) => (
      <li
          key={index}
          onClick={(e) => props.handleChange(option.name)}
      >
          {option.name}
          <p
              role="separator"
              className="divider"
          />
      </li>

  ));

  return (
      <div className={'col-sm-6 ' + props.width}>
          <div className="dropdown">
              <div
                  className="md-input dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
              >
                  <InputContainer
                      label={props.label}
                      type="text"
                      value={props.value || ''}
                      required={props.required}
                      onChange={(v) => v}
                  />
                  <span className="d-arrow-down icon-error-input"/>
              </div>
              <ul className="dropdown-menu">
                  {selectOptions}
              </ul>
          </div>
          <div className="gap-20"/>
      </div>
  );
};

export default SelectComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/select/Select.component.tsx